import * as yup from 'yup'

export default yup.object().shape({
  name: yup.string().min(1).required('Required field'),
  siteId: yup.string().min(1).required('Required field'),
})
